import{h as o,i as r}from"./chunk-2JBE4HP3.mjs";var m=new o({locale:r});export{m as a};
